import { fetchUserReplyTemplatesPublic } from '../../services';
import { showAlert } from '../../slices/alertSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';

import type { IUserReplyTemplatesListResponse } from '../../types/replyTemplates';

export const getReplyTemplatesThunk = createAppAsyncThunk<
  IUserReplyTemplatesListResponse,
  void,
  { rejectValue: string }
>('chats/getReplyTemplatesThunk', async (_, _thunkApi) => {
  const { fulfillWithValue, rejectWithValue, extra: context, dispatch } = _thunkApi;

  try {
    const response = await fetchUserReplyTemplatesPublic(context);

    return fulfillWithValue(response);
  } catch (e) {
    dispatch(showAlert({ message: 'Сервисная ошибка. Попробуйте позже.' }));

    return rejectWithValue(e instanceof Error ? e.message : String(e));
  }
});
